import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/out/order/approverecord/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/out/order/approverecord/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/out/order/approverecord/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/out/order/approverecord/submit', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/out/order/approverecord/submit', params,options)

export const audit = (params, options) =>
  request.post('/api/v4ward/out/order/approverecord/audit', params,options)

export const approvePermissions = (params, options) =>
request.post('/api/v4ward/out/order/approverecord/permissions', qs.stringify(params),options)



